module.exports = __webpack_public_path__ + "static/media/company-2.bfb9dbbe.png";